import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../../shared/models/User';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.css']
})
export class VerifyEmailComponent implements OnInit {

  constructor(private http: HttpService, private global: GlobalService, private router: Router, private actRoute: ActivatedRoute) { }

  ngOnInit(): void {
    var verifyID = this.actRoute.snapshot.params.id;
    if (verifyID) {
      this.Verify(verifyID);
      //this.http.verifyUserEmail(verifyID).then(wrap => {
      //  if (wrap.StatusCode == "200") {
      //    this.global.setCurrentUser(wrap.Content);
      //    this.router.navigate(['/projectLibrary']);
      //  }
      //  else if(wrap.StatusCode == "400") {
      //    //user doesn't exist
      //    this.router.navigate(['/']);
      //  }
      //});
    }
  }

  async Verify(hash: string) {
    await this.http.verifyUserEmail(hash).then(wrap => {
      if (wrap.StatusCode == "200") {
        this.global.setCurrentUser((<User>wrap.Content));
        this.router.navigate(['/dashboard']);
      }
      else if (wrap.StatusCode == "400") {
        //user doesn't exist
        this.router.navigate(['/']);
      }
    });
  }

}
